import { ECheckoutStatus } from '../../../constants/enums';
import { useAppConfig } from '../../../hooks/use-app-config';
import { mobileSDKUtils } from '../../../utils/mobile-sdk-utils';
import { useDeviceHelper } from '../../../hooks/use-device-helper';
import { usePaymentState } from '../../Checkout/hooks/use-payment-state';

export function usePartialScreen() {
  const { featureFlags } = useAppConfig();
  const { isMobile } = useDeviceHelper();
  const checkoutStatus = usePaymentState((state) => state.checkoutStatus);

  if ((featureFlags?.checkout_partial_screen_mobile || mobileSDKUtils.isMobileSdk()) && isMobile) {
    return checkoutStatus === ECheckoutStatus.INIT;
  }

  return false;
}
